import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { FullPageSpinner } from '@/shared/ui/spinner';

import { useAuth } from '../use-auth';

/** Landing page for OAuth and email-confirmation redirects. Supabase exchanges the code; we just wait. */
export function AuthCallbackPage() {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authenticated') void navigate({ to: '/', replace: true });
    if (status === 'anonymous') void navigate({ to: '/sign-in', replace: true });
  }, [status, navigate]);

  return <FullPageSpinner label="Finishing sign in" />;
}
